/* @flow */

export const make = (namespace: string) => {
  return {
    get: () => window.localStorage.getItem(namespace),
    set: (val: string) => window.localStorage.setItem(namespace, val) && val,
  };
};
